/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useDebouncedEffect from './useDebouncedEffect';

const getPromotions = async (search) => {
  const url = `https://us-central1-ftc-arda-production.cloudfunctions.net/api/public/bms/promotions/search?title=${search}`;
  const response = await fetch(url, {
    method: 'GET',
  });
  const result = await response.json();
  return result;
};

const Main = ({ plugin }) => {
  const [searchVal, setSearchVal] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [fieldValue, setFieldValue] = useState(
    JSON.parse(plugin.getFieldValue(plugin.fieldPath)),
  );
  const [promoList, setPromoList] = useState([]);
  const [selected, setSelected] = useState(JSON.parse(plugin.getFieldValue(plugin.fieldPath)));

  const selectPromo = (newVal) => {
    setFieldValue(newVal);
    setSelected(newVal);
    setPromoList([]);
    setSearchVal('');
  };

  useDebouncedEffect(() => {
    plugin.setFieldValue(plugin.fieldPath, JSON.stringify(fieldValue));
  }, 300, [fieldValue]);

  useDebouncedEffect(
    () => {
      setError('');
      if (searchVal) {
        setLoading(true);
        (async () => {
          setLoading(false);
          try {
            const promoResult = await getPromotions(searchVal);
            if (promoResult.length === 0) {
              setError('Promo not found');
            }
            setPromoList(promoResult);
          } catch (e) {
            setError('Error requesting data.');
          }
        })();
      } else {
        setPromoList([]);
      }
    },
    500,
    [searchVal],
  );

  return (
    <>
      {fieldValue && fieldValue.title ? (
        <>
          <p className="selected">
            {`${selected.title} (CODE: ${selected.code})`}
            <i tabIndex="-1" role="button" onClick={() => selectPromo({})}>
              X
            </i>
          </p>
          <div className="edit">
            <div>
              <p>Description</p>
              <textarea
                value={fieldValue.description_body}
                readOnly
              />
            </div>
            <div>
              <p>Terms and Conditions</p>
              <textarea
                value={fieldValue.terms}
                readOnly
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <input
            value={searchVal}
            placeholder="Search for promotions..."
            onChange={e => setSearchVal(e.target.value)}
          />
          {loading && <p className="loading">Searching...</p>}
          {error && <p className="error">{error}</p>}
          {promoList.length > 0 && (
            <div className="results">
              {promoList.map(promo => (
                !promo.title.toLowerCase().includes('expired') && (
                  <div
                    key={promo.id}
                    tabIndex="-1"
                    role="button"
                    onClick={() => selectPromo(promo)}
                  >
                    {`${promo.title} - (CODE: ${promo.code})`}
                  </div>
                )
              ))}
            </div>
          )}
        </>
      )}
    </>
  );
};

Main.propTypes = {
  plugin: PropTypes.object,
};

export default Main;
